module.exports = __webpack_public_path__ + "img/l-d.6aca1c58.png";